import { FiFileText, FiMessageCircle, FiPenTool, FiSend } from "react-icons/fi";

export const steps = [
  {
    number: "01",
    icon: FiMessageCircle,
    title: "Discovery Call",
    label: "Understand",
    text: "We talk about your business, goals, current situation, and what you really need.",
    points: ["Goals", "Problems", "Best direction"],
  },
  {
    number: "02",
    icon: FiFileText,
    title: "Concept & Offer",
    label: "Plan",
    text: "You receive a clear concept, scope, timeline, and pricing before anything gets built.",
    points: ["Scope", "Timeline", "Budget"],
  },
  {
    number: "03",
    icon: FiPenTool,
    title: "Design & Build",
    label: "Create",
    text: "We design and develop your website or app with regular check-ins and room for feedback.",
    points: ["Design", "Development", "Feedback"],
  },
  {
    number: "04",
    icon: FiSend,
    title: "Launch & Care",
    label: "Grow",
    text: "Launch day, handover, and optional support for maintenance, updates, and marketing.",
    points: ["Launch", "Handover", "Support"],
  },
];
